import React from "react";
import { ThunderboltOutlined } from "@ant-design/icons";

const { Tooltip, Tag } = require("antd");

const AutosledExpeditedTag = () => {
  return (
    <Tooltip
      color="#fff"
      title="A shipment has either been sitting too long, had multiple cancellations,
    or a customer offers us more money to get it to them faster, so we artificially
    increase the price."
    >
      <Tag color="processing">
        <ThunderboltOutlined /> Autosled Expedited
      </Tag>
    </Tooltip>
  );
};

export default AutosledExpeditedTag;
